import { SearchIcon } from "lucide-react";
import React, { useState } from "react";
import Categoryheader from "../VoucherModule/Components/VocuherCategory";
import ControlledAccordions from "../VoucherModule/Components/Collapsable";

const AddExistingVoucher = () => {
  const [selected, setselected] = useState(1);

  return (
    <div className=" bg-white ml-[2.083333vw] mt-[1.5185vh] mr-[2.638888vw] overflow-y-scroll no-scrollbar">
      <Categoryheader />

      <div className="flex flex-row mt-9 items-start justify-start mx-[2.522222vw] gap-x-3 ">
        <button
          className={` w-[10vw] ${
            selected === 0
              ? "border-[3px] border-purple-700 bg-[#EAD8FC] "
              : "border-[1px] border-zinc-300"
          } rounded-md px-5 py-2 text-[2.2003745vh] font-medium font-outfit text-[#CAC4D0] flex items-center justify-center flex-row`}
          onClick={() => setselected(0)}>
          {" "}
          <span
            className={`px-2 ${
              selected === 0 ? "text-[#333333]" : "text-[#333333]"
            }`}>
            Common
          </span>
        </button>
        <button
          className={` w-[10vw] ${
            selected === 1
              ? "border-[3px] border-purple-700 bg-[#EAD8FC] "
              : "border-[1px] border-zinc-300"
          } rounded-md px-5 py-2 text-[2.2003745vh] font-medium font-outfit text-[#CAC4D0] flex items-center justify-center flex-row`}
          onClick={() => setselected(1)}>
          {" "}
          <span
            className={`px-2 ${
              selected === 1 ? "text-[#333333]" : "text-[#333333]"
            }`}>
            Specific
          </span>
        </button>
      </div>

      <div className="w-[80%] ml-[2.3vw] mt-6 h-[8vh] box-border flex flex-row">
        <div className="bg-[#F5F6F8] rounded-lg flex w-[80%] flex-row items-center border border-grey-400 h-[65%] allProductSearchBoxContainer">
          <SearchIcon className=" mx-2 w-[20px] h-[20px]" color="#83899F" />
          <input
            type="text"
            placeholder="Search by ID, Name..."
            className=" w-[90%] text-[#83899F] allProductSearchBox outfit-regular"
          />
        </div>
      </div>

      <div className="gap-y-4 grid">
        <ControlledAccordions />
        <ControlledAccordions />
        <ControlledAccordions />
      </div>
    </div>
  );
};

export default AddExistingVoucher;
